export interface RedmineIssueDto {
  id: number;
  project?: { id: number; name: string };
  tracker?: { id: number; name: string };
  status?: { id: number; name: string };
  priority?: { id: number; name: string };
  author?: { id: number; name: string };
  assignedTo?: { id: number; name: string };
  category?: { id: number; name: string };
  subject?: string;
  description?: string;
  start_date?: string;
  due_date?: string;
  done_ratio?: number;
  estimated_hours?: number;
  pessimistic_estimated_hours?: number;
  customFields?: any[];
  created_on?: string;
  updated_on?: string;
  parent_id?: number;
}

export interface RedmineTimeTrackDto {
  id: number;
  project?: { id: number; name: string };
  user?: { id: number; name: string };
  issue?: { id: number; name: string };
  activity?: { id: number; name: string };
  hours?: number;
  comments?: string;
  spent_on?: string;
  created_on?: string;
  updated_on?: string;
}

export enum TimeTrackRequestType {
  EXISTING_TIME_ADJUSTMENT = 'EXISTING_TIME_ADJUSTMENT',
  NEW_TIME_ENTRY = 'NEW_TIME_ENTRY',
}

export enum TimeTrackActivity {
  HOME = 'HOME',
  OFFICE = 'OFFICE',
  TRANSIT = 'TRANSIT',
}

export interface WorkloadChangeItem {
  timeEntryId?: number;
  ticketId?: number;
  trackingDate?: string;
  currentTimeTrack?: number;
  correctTicketId?: number;
  correctTrackingDate?: string;
  correctTimeTrack?: number;
  activity?: TimeTrackActivity;
  descriptionOfWork?: string;
}

export enum TimeTrackChangeRequestStatus {
  PENDING_REVIEW = 'PENDING_REVIEW',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  APPLIED = 'APPLIED',
  FAILED = 'FAILED',
}

export interface TimeTrackChangeRequestDto {
  id: string;
  requestType: TimeTrackRequestType;
  reasonForChange: string;
  changes: WorkloadChangeItem[];
  // Returned by task-management only; business-engine requests have no status and are always reviewable.
  status?: TimeTrackChangeRequestStatus;
  rejectionReason?: string | null;
  reviewedAt?: string | null;
}

export interface ReviewTimeTrackCommand {
  changeRequestId: string;
  isApproved: 'YES' | 'NO';
  reason?: string;
}

interface TaskManagementNamedEntityDto {
  id: number;
  name: string;
}

export interface TaskManagementIssueDto {
  id: number;
  subject: string;
  author: TaskManagementNamedEntityDto;
  assignee?: TaskManagementNamedEntityDto | null;
  project: TaskManagementNamedEntityDto;
  status: TaskManagementNamedEntityDto;
  dueDate?: string | null;
  estimatedHours?: number | null;
  optimisticEstimatedHours?: number | null;
  mostLikelyEstimatedHours?: number | null;
  pessimisticEstimatedHours?: number | null;
}

export interface TaskManagementTimeEntryDto {
  id: number;
  issueId?: number | null;
  hours: number;
  comments?: string | null;
  spentOn: string;
  createdOn?: string | null;
  updatedOn?: string | null;
}
